import NotificationListItem from "@/pages/notifications/components/NotificationListItem";
import { cn } from "@/utils/cn";
import type { NotificationGroup } from "@/pages/notifications/utils";
import type { NotificationStatus } from "@/contexts/NotificationsProvider";
import type { Notification } from "@/pages/notifications/types";

export interface GroupedNotificationListProps {
  groups: NotificationGroup<Notification>[];
  getStatus: (n: Notification) => NotificationStatus;
  onMarkRead: (n_id: string) => void;
  size?: "sm" | "lg";
}

const SIZE_CLASSES = {
  sm: { sectionLabel: "px-4 pb-1.5 pt-3", item: "" },
  lg: { sectionLabel: "px-6 pb-1.5 pt-4", item: "px-6" },
} as const;

function GroupedNotificationList({
  groups,
  getStatus,
  onMarkRead,
  size = "sm",
}: GroupedNotificationListProps) {
  const s = SIZE_CLASSES[size];

  return (
    <div>
      {groups.map((group) => (
        <div key={group.label}>
          <div
            className={cn(
              "text-[10.5px] font-bold uppercase tracking-wider text-text-muted",
              s.sectionLabel
            )}
          >
            {group.label}
          </div>
          <div
            className={
              size === "lg" ? "divide-y divide-border-light" : undefined
            }
          >
            {group.items.map((n) => (
              <NotificationListItem
                key={n.n_id}
                notification={n}
                status={getStatus(n)}
                onMarkRead={onMarkRead}
                className={s.item}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default GroupedNotificationList;
